import clsx from 'clsx';

interface IProps {
    isWritting: boolean;
    isSendCheckBtnDisabled: boolean;
    isInvalidAddressModalOpen: boolean;
    isBalanceNotEnoughModalOpen: boolean;
    onClickSendCheckBtn: () => void;
    onClickSendCancelBtn: () => void;
    onClickInvalidAddressModalClose: () => void;
    onClickBalanceNotEnoughModalConfirm: () => void;
}

const SendCheckBtn = ({
    isWritting,
    isSendCheckBtnDisabled,
    isInvalidAddressModalOpen,
    isBalanceNotEnoughModalOpen,
    onClickSendCheckBtn,
    onClickSendCancelBtn,
    onClickInvalidAddressModalClose,
    onClickBalanceNotEnoughModalConfirm,
}: IProps) => {
    return (
        <>
            {isWritting && (
                <div className="send-action-buttons">
                    <button
                        type="button"
                        className="send-cancel-btn text-base font-semibold"
                        id="sendCancelBtn"
                        onClick={onClickSendCancelBtn}
                    >
                        취소
                    </button>
                    <button
                        type="button"
                        className={clsx('send-next-btn text-base font-semibold', isSendCheckBtnDisabled ? 'disabled' : 'active')}
                        id="sendNextBtn"
                        onClick={onClickSendCheckBtn}
                        disabled={isSendCheckBtnDisabled}
                    >
                        다음
                    </button>
                </div>
            )}

            {/* 유효하지 않은 주소 모달 */}
            <div className={clsx('modal-overlay', !isInvalidAddressModalOpen && 'hidden')} id="invalidAddressModal">
                <div className="modal-content modal-small">
                    <button type="button" className="modal-close" onClick={onClickInvalidAddressModalClose}>
                        <img src="./images/close-icon.png" alt="닫기" className="close-icon" />
                    </button>

                    <div className="modal-body">
                        <h2 className="modal-confirm-title text-base font-bold">유효하지 않는 주소입니다.</h2>

                        <div className="modal-confirm-buttons">
                            <button
                                type="button"
                                className="modal-confirm-yes text-lg font-semibold"
                                onClick={onClickInvalidAddressModalClose}
                                style={{ width: '100%' }}
                            >
                                확인
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* 잔액 부족 모달 */}
            <div className={clsx('modal-overlay', !isBalanceNotEnoughModalOpen && 'hidden')} id="balanceNotEnoughModal">
                <div className="modal-content modal-medium">
                    <button type="button" className="modal-close" onClick={onClickBalanceNotEnoughModalConfirm}>
                        <img src="./images/close-icon.png" alt="닫기" className="modal-close-icon" />
                    </button>

                    <div className="modal-body">
                        <div className="modal-icon-warning">
                            <img src="./images/alert-icon.png" alt="경고" className="modal-icon" />
                        </div>

                        <h2 className="modal-warning-title text-lg font-bold">보유금을 초과할 수 없습니다.</h2>

                        <button
                            type="button"
                            className="modal-button text-lg font-semibold"
                            onClick={onClickBalanceNotEnoughModalConfirm}
                        >
                            확인
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SendCheckBtn;

